import { render, staticRenderFns } from "./CandleMap.vue?vue&type=template&id=40a2d160&scoped=true&"
import script from "./CandleMap.vue?vue&type=script&lang=js&"
export * from "./CandleMap.vue?vue&type=script&lang=js&"
import style0 from "./CandleMap.vue?vue&type=style&index=0&id=40a2d160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a2d160",
  null
  
)

export default component.exports